import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const items = [
  "Real Estate",
  "Clinics & Healthcare",
  "Automobile Dealers",
  "Restaurants",
  "Retail & E-com",
  "Education",
  "Local Services",
  "Growing SMEs",
];

export default function Trust() {
  const sectionRef = useRef(null);
  const headlineRef = useRef(null);

  useEffect(() => {
    const trigger = sectionRef.current;
    if (!trigger) return;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;

    gsap.fromTo(
      headlineRef.current,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      }
    );

    return () => {
      ScrollTrigger.getAll().forEach((st) => {
        if (st.trigger === trigger) st.kill();
      });
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-14 border-y border-[var(--hairline)] bg-[var(--body-bg)]" data-testid="trust-section">
      <div className="container-x">
        <p
          ref={headlineRef}
          className="text-center text-xs font-mono tracking-[0.25em] uppercase text-[var(--muted-text)]"
        >
          Built for businesses that want to win the next decade
        </p>
        <div className="mt-8 relative overflow-hidden">
          <div className="marquee">
            {[...items, ...items].map((t, i) => (
              <div key={i} className="flex items-center gap-3 text-[var(--muted-text)] text-base">
                <span className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 border border-[var(--glass-border)] bg-white/50 hover:bg-orange-500/5 hover:border-[var(--card-hover-border)] transition-colors">
                  <span
                    className="inline-block h-1.5 w-1.5 rounded-full"
                    style={{ background: "var(--brand)", boxShadow: "0 0 8px var(--brand)" }}
                  />
                  <span className="font-medium tracking-tight">{t}</span>
                </span>
              </div>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--body-bg)] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--body-bg)] to-transparent" />
        </div>
      </div>
    </section>
  );
}
